import { toAbsoluteUrl } from '_metronic/helpers'

interface BoxProps {
	product_type: string
	product_num: string
	product_img: string
}

const Box: React.FC<BoxProps> = ({ product_img, product_num }) => {
	return (
		<div
			className="d-flex flex-column align-items-start p-5 position-relative"
			style={{ backgroundColor: '#F6F6F6', borderRadius: '8px' }}>
			{/* begin:: Product Image */}
			<img className="mx-auto" src={product_img} alt="Product" />
			{/* end:: Product Image */}

			{/* begin:: Product Name */}
			<span className="fs-4 fw-bold text-kumopack-grey-700 text-start">ชื่อสินค้า</span>
			<span className="fs-7 fw-medium text-kumopack-grey-500 text-start">
				จำนวนคงเหลือ: {product_num}
			</span>
			{/* end:: Product Name */}

			{/* begin:: Action */}
			<div
				className="position-absolute cursor-pointer"
				style={{
					right: 20,
					top: 10,
					width: 30,
					height: 30,
					borderRadius: '16px',
					backgroundColor: '#D9D9D9',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				<img src={toAbsoluteUrl('/media/icons/kumopack/Union.png')} alt="Union Icon" />
			</div>
			{/* end:: Action */}
		</div>
	)
}

interface Props {
	products: any[]
}

const ProductBox: React.FC<Props> = ({ products }) => {
	return (
		<>
			<div className="row g-5 px-4 py-4" style={{ minHeight: '600px' }}>
				{products.map((p, idx) => (
					<div className="col-12 col-xl-3" key={`products-${idx}`}>
						<Box {...p} />
					</div>
				))}
			</div>

			<hr
				style={{
					background: 'transparent',
					borderBottom: '1px solid #CCC',
					borderTop: 0,
					borderLeft: 0,
					borderRight: 0,
				}}
			/>

			{/* begin:: Desktop Table Pagination */}
			<div className="d-none d-xl-flex flex-row justify-content-between align-items-center px-5 pb-5">
				<div>
					<button className="btn btn-sm white-button">{'< Previous'}</button>
				</div>
				<div>
					<div
						className="d-inline-block px-5 rounded-circle"
						style={{ backgroundColor: '#F9FAFB', padding: '12px 20px' }}>
						1
					</div>
					<div className="d-inline-block mx-5">2</div>
					<div className="d-inline-block mx-5">3</div>
					<div className="d-inline-block mx-5">...</div>
					<div className="d-inline-block mx-5">8</div>
					<div className="d-inline-block mx-5">9</div>
					<div className="d-inline-block mx-5">10</div>
				</div>
				<div>
					<button className="btn btn-sm white-button">{'Next >'}</button>
				</div>
			</div>
			{/* end:: Desktop Table Pagination */}

			{/* begin:: Mobile Table Pagination */}
			<div className="d-flex d-xl-none flex-row justify-content-between align-items-center px-5 pb-5">
				<div>
					<button className="btn btn-sm white-button">{'<'}</button>
				</div>
				<div>Page 1 of 10</div>
				<div>
					<button className="btn btn-sm white-button">{'>'}</button>
				</div>
			</div>
			{/* end:: Mobile Table Pagination */}
		</>
	)
}

export default ProductBox
